$(function (document, window, index) {
    $('#show_modal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget);
        var url = button.data('url');
        var modal = $(this);
        modal.find('#btn-confirm').attr('href', url);
    });

    $('.minimal').iCheck({
        checkboxClass: 'icheckbox_square-blue',
        radioClass: 'iradio_square-blue',
        increaseArea: '20%' // optional
    });

    $('#statistics_datatable_pages').DataTable({
        "paging": true,
        "lengthChange": true,
        "searching": true,
        "ordering": true,
        "order": [[ 1, 'desc' ]],
        "info": true,
        "autoWidth": false,
        "responsive": true,
        "rowReorder": true,
        "language": {
            "sEmptyTable": "Nobenih podatkov ni na voljo",
            "sInfo": "Prikazujem _START_ do _END_ od _TOTAL_ zapisov",
            "sInfoEmpty": "Prikazujem 0 do 0 od 0 zapisov",
            "sInfoFiltered": "(filtrirano od _MAX_ vseh zapisov)",
            "sInfoPostFix": "",
            "sInfoThousands": ",",
            "sLengthMenu": "Prikaži _MENU_ zapisov",
            "sLoadingRecords": "Nalagam...",
            "sProcessing": "Obdelujem...",
            "sSearch": "Išči:",
            "sZeroRecords": "Nobeden zapis ne ustreza",
            "oPaginate": {
                "sFirst": "Prvi",
                "sLast": "Zadnji",
                "sNext": "Nasl.",
                "sPrevious": "Pred."
            },
            "oAria": {
                "sSortAscending": ": vključite za naraščujoči sort",
                "sSortDescending": ": vključite za padajoči sort"
            }
        }
    });

    $('#statistics_datatable_keywords').DataTable({
        "paging": true,
        "lengthChange": true,
        "searching": true,
        "ordering": true,
        "order": [[ 1, 'desc' ]],
        "info": true,
        "autoWidth": false,
        "responsive": true,
        "rowReorder": true,
        "language": {
            "sEmptyTable": "Nobenih podatkov ni na voljo",
            "sInfo": "Prikazujem _START_ do _END_ od _TOTAL_ zapisov",
            "sInfoEmpty": "Prikazujem 0 do 0 od 0 zapisov",
            "sInfoFiltered": "(filtrirano od _MAX_ vseh zapisov)",
            "sInfoPostFix": "",
            "sInfoThousands": ",",
            "sLengthMenu": "Prikaži _MENU_ zapisov",
            "sLoadingRecords": "Nalagam...",
            "sProcessing": "Obdelujem...",
            "sSearch": "Išči:",
            "sZeroRecords": "Nobeden zapis ne ustreza",
            "oPaginate": {
                "sFirst": "Prvi",
                "sLast": "Zadnji",
                "sNext": "Nasl.",
                "sPrevious": "Pred."
            },
            "oAria": {
                "sSortAscending": ": vključite za naraščujoči sort",
                "sSortDescending": ": vključite za padajoči sort"
            }
        }
    });


    var invoices_table = $('#invoices_table').DataTable({
        "paging": true,
        "lengthChange": true,
        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "Vsi"]],
        "iDisplayLength": 50,
        "searching": true,
        "ordering": true,
        "info": true,
        "autoWidth": false,
        "responsive": true,
        "language": {
            "sEmptyTable": "Nobenih podatkov ni na voljo",
            "sInfo": "Prikazujem _START_ do _END_ od _TOTAL_ zapisov",
            "sInfoEmpty": "Prikazujem 0 do 0 od 0 zapisov",
            "sInfoFiltered": "(filtrirano od _MAX_ vseh zapisov)",
            "sInfoPostFix": "",
            "sInfoThousands": ",",
            "sLengthMenu": "Prikaži _MENU_ zapisov",
            "sLoadingRecords": "Nalagam...",
            "sProcessing": "Obdelujem...",
            "sSearch": "Išči:",
            "sZeroRecords": "Nobeden zapis ne ustreza",
            "oPaginate": {
                "sFirst": "Prvi",
                "sLast": "Zadnji",
                "sNext": "Nasl.",
                "sPrevious": "Pred."
            },
            "oAria": {
                "sSortAscending": ": vključite za naraščujoči sort",
                "sSortDescending": ": vključite za padajoči sort"
            }
        },
        "columnDefs": [
            { "width": "20%", "targets": 3 }
        ]
    });

    var table_moving_images = $('#data_table_moving_images').DataTable({
        "paging": true,
        "lengthChange": true,
        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "Vsi"]],
        "searching": true,
        "ordering": true,
        "info": true,
        "autoWidth": false,
        rowReorder: true,
        "responsive": true,
        "language": {
            "sEmptyTable": "Nobenih podatkov ni na voljo",
            "sInfo": "Prikazujem _START_ do _END_ od _TOTAL_ zapisov",
            "sInfoEmpty": "Prikazujem 0 do 0 od 0 zapisov",
            "sInfoFiltered": "(filtrirano od _MAX_ vseh zapisov)",
            "sInfoPostFix": "",
            "sInfoThousands": ",",
            "sLengthMenu": "Prikaži _MENU_ zapisov",
            "sLoadingRecords": "Nalagam...",
            "sProcessing": "Obdelujem...",
            "sSearch": "Išči:",
            "sZeroRecords": "Nobeden zapis ne ustreza",
            "oPaginate": {
                "sFirst": "Prvi",
                "sLast": "Zadnji",
                "sNext": "Nasl.",
                "sPrevious": "Pred."
            },
            "oAria": {
                "sSortAscending": ": vključite za naraščujoči sort",
                "sSortDescending": ": vključite za padajoči sort"
            }
        },
        "columnDefs": [
            { "width": "20%", "targets": 3 }
        ]
    });

    table_moving_images.on('row-reorder', function ( e, diff, edit ) {
        $.ajax({
            data: edit.values,
            type: 'POST',
            url: '/administracija/nastavitve/save-order',
            success:(function(data) {

            })
        });
    });

    var pages_table = $('#pages_table').DataTable({
        "paging": true,
        "lengthChange": true,
        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "Vsi"]],
        "searching": true,
        "ordering": true,
        "info": true,
        "autoWidth": false,
        rowReorder: true,
        "responsive": true,
        "language": {
            "sEmptyTable": "Nobenih podatkov ni na voljo",
            "sInfo": "Prikazujem _START_ do _END_ od _TOTAL_ zapisov",
            "sInfoEmpty": "Prikazujem 0 do 0 od 0 zapisov",
            "sInfoFiltered": "(filtrirano od _MAX_ vseh zapisov)",
            "sInfoPostFix": "",
            "sInfoThousands": ",",
            "sLengthMenu": "Prikaži _MENU_ zapisov",
            "sLoadingRecords": "Nalagam...",
            "sProcessing": "Obdelujem...",
            "sSearch": "Išči:",
            "sZeroRecords": "Nobeden zapis ne ustreza",
            "oPaginate": {
                "sFirst": "Prvi",
                "sLast": "Zadnji",
                "sNext": "Nasl.",
                "sPrevious": "Pred."
            },
            "oAria": {
                "sSortAscending": ": vključite za naraščujoči sort",
                "sSortDescending": ": vključite za padajoči sort"
            }
        },
        "columnDefs": [
            { "width": "20%", "targets": 3 }
        ]
    });

    pages_table.on('row-reorder', function ( e, diff, edit ) {
        $.ajax({
            data: edit.values,
            type: 'POST',
            url: '/administracija/strani/save-order',
            success:(function(data) {

            })
        });
    });

    var categories_table = $('#categories_table').DataTable({
        "paging": true,
        "lengthChange": true,
        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "Vsi"]],
        "searching": true,
        "ordering": true,
        "info": true,
        "autoWidth": false,
        rowReorder: false,
        "responsive": true,
        "language": {
            "sEmptyTable": "Nobenih podatkov ni na voljo",
            "sInfo": "Prikazujem _START_ do _END_ od _TOTAL_ zapisov",
            "sInfoEmpty": "Prikazujem 0 do 0 od 0 zapisov",
            "sInfoFiltered": "(filtrirano od _MAX_ vseh zapisov)",
            "sInfoPostFix": "",
            "sInfoThousands": ",",
            "sLengthMenu": "Prikaži _MENU_ zapisov",
            "sLoadingRecords": "Nalagam...",
            "sProcessing": "Obdelujem...",
            "sSearch": "Išči:",
            "sZeroRecords": "Nobeden zapis ne ustreza",
            "oPaginate": {
                "sFirst": "Prvi",
                "sLast": "Zadnji",
                "sNext": "Nasl.",
                "sPrevious": "Pred."
            },
            "oAria": {
                "sSortAscending": ": vključite za naraščujoči sort",
                "sSortDescending": ": vključite za padajoči sort"
            }
        },
        "columnDefs": [
            { "width": "20%", "targets": 3 }
        ]
    });

    categories_table.on('row-reorder', function ( e, diff, edit ) {
        $.ajax({
            data: edit.values,
            type: 'POST',
            url: '/administracija/kategorije/save-order',
            success:(function(data) {

            })
        });
    });

    tinymce.init({
        selector: '#page_content',
        plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table contextmenu paste imagetools imageupload"
        ],
        toolbar: "undo redo | bold italic | bullist numlist outdent indent | link image | imageupload | code | fullscreen | styleselect | alignleft aligncenter alignright alignjustify",
        relative_urls: false
    });

    tinymce.init({
        selector: '#product_content',
        plugins: [
            "advlist autolink lists link charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table contextmenu paste"
        ],
        toolbar: "undo redo | bold italic | bullist numlist outdent indent | code | fullscreen | styleselect | alignleft aligncenter alignright alignjustify",
        relative_urls: false
    });

    tinymce.init({
        selector: '#product_content_enaa',
        plugins: [
            "advlist autolink lists link charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table contextmenu paste"
        ],
        toolbar: "undo redo | bold italic | bullist numlist outdent indent | code | fullscreen | styleselect | alignleft aligncenter alignright alignjustify",
        relative_urls: false
    });

    tinymce.init({
        selector: '#product_content_ideo',
        plugins: [
            "advlist autolink lists link charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table contextmenu paste"
        ],
        toolbar: "undo redo | bold italic | bullist numlist outdent indent | code | fullscreen | styleselect | alignleft aligncenter alignright alignjustify",
        relative_urls: false
    });

    tinymce.init({
        selector: '#ideo_insurance',
        plugins: [
            "advlist autolink lists link charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table contextmenu paste"
        ],
        toolbar: "undo redo | bold italic | bullist numlist outdent indent | code | fullscreen | styleselect | alignleft aligncenter alignright alignjustify",
        relative_urls: false
    });

    $('input[type=radio][name=mimovrste_export]').on('ifChecked', function (event) {
        if (this.value == 1) {
           $('.mimovrste').removeClass('hidden');
        }
        else {
            $('.mimovrste').addClass('hidden');
       }
    });

    $('input[type=radio][name=enaa_export]').on('ifChecked', function (event) {
        if (this.value == 1) {
            $('.enaa').removeClass('hidden');
        }
        else {
            $('.enaa').addClass('hidden');
        }
    });

    $('input[type=radio][name=ideo_export]').on('ifChecked', function (event) {
        if (this.value == 1) {
            $('.ideo').removeClass('hidden');
        }
        else {
            $('.ideo').addClass('hidden');
        }
    });

    initProductsTable();

    $('#product-category').on('change', function () {
        var obj = this;
        $.ajax({
            data: {
                id: obj.value
            },
            type: 'POST',
            url: '/administracija/produkti/get-products',
            success:(function(rsp) {
                $('#products').html(rsp);
                initProductsTable();
            })
        });
    });

    $('#invoice_date').datepicker({
        format: 'dd.mm.yyyy',
    });

    $('#invoice_date.new').datepicker('setDate', new Date());
    $('#invoice_date.new').datepicker('update');

    $('#invoice_from').datepicker({
        format: 'dd.mm.yyyy',
    });

    $('#invoice_from').datepicker('setDate', new Date());
    $('#invoice_from').datepicker('update');

    $('#invoice_to').datepicker({
        format: 'dd.mm.yyyy',
    });

    $('#invoice_to').datepicker('setDate', new Date());
    $('#invoice_to').datepicker('update');

    $('.statistics-filters').on('change', function() {
        var year =  $('#invoice-year').val();
        var month =  $('#invoice-month').val();

        $.ajax({
            url: '/administracija/statistika/racuni',
            type: 'post',
            data : {
                month: month,
                year: year
            },
            dataType: 'JSON'
        }).done(function (rsp) {
            var statistics = rsp.total;
            var labels = Object.keys(statistics);

            var data_sold_chart = {
                labels: labels,
                datasets: [
                    {
                        label: "Page Views",
                        fillColor: "rgba(220,220,220,0.2)",
                        strokeColor: "rgba(220,220,220,1)",
                        pointColor: "rgba(220,220,220,1)",
                        pointStrokeColor: "#fff",
                        pointHighlightFill: "#fff",
                        pointHighlightStroke: "rgba(220,220,220,1)",
                        data: statistics
                    }
                ]
            };
            var chartOptions = {
                ///Boolean - Whether grid lines are shown across the chart
                scaleShowGridLines : true,
                //String - Colour of the grid lines
                scaleGridLineColor : "rgba(0,0,0,.05)",
                //Number - Width of the grid lines
                scaleGridLineWidth : 1,
                //Boolean - Whether to show horizontal lines (except X axis)
                scaleShowHorizontalLines: true,
                //Boolean - Whether to show vertical lines (except Y axis)
                scaleShowVerticalLines: true,
                //Boolean - Whether the line is curved between points
                bezierCurve : true,
                //Number - Tension of the bezier curve between points
                bezierCurveTension : 0.4,
                //Boolean - Whether to show a dot for each point
                pointDot : true,
                //Number - Radius of each point dot in pixels
                pointDotRadius : 4,
                //Number - Pixel width of point dot stroke
                pointDotStrokeWidth : 1,
                //Number - amount extra to add to the radius to cater for hit detection outside the drawn point
                pointHitDetectionRadius : 20,
                //Boolean - Whether to show a stroke for datasets
                datasetStroke : true,
                //Number - Pixel width of dataset stroke
                datasetStrokeWidth : 2,
                //Boolean - Whether to fill the dataset with a colour
                datasetFill : true,
                //String - A legend template
                legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<datasets.length; i++){%><li><span style=\"background-color:<%=datasets[i].strokeColor%>\"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>",
                responsive: true
            };

            $('#total_sold_chart').remove();
            $('#graph-container').append('<canvas id="total_sold_chart"></canvas>');
            var can = jQuery('#total_sold_chart');
            var ctx = can.get(0).getContext("2d");
            var container = can.parent().parent();

            var $container = jQuery(container);
            can.attr('width', $container.width()); //max width
            can.attr('height', $container.height()); //max height

            var total_sold_chart = new Chart(ctx).Line(data_sold_chart, chartOptions);

            var statistics = [];

            for (var stats in rsp.products) {
                statistics.push([stats, rsp.products[stats]]);
            }

            var bar_data = {
                data: statistics,
                color: "#3c8dbc"
            };

            $.plot($("#sold-items"), [bar_data], {
                grid: {
                    borderWidth: 1,
                    borderColor: "#f3f3f3",
                    tickColor: "#f3f3f3"
                },
                series: {
                    bars: {
                        show: true,
                        barWidth: 0.5,
                        align: "center"
                    }
                },
                xaxis: {
                    mode: "categories",
                    tickLength: 0
                }
            });
        });
    });

    $('.filters').on('change', function () {
        var year =  $('#invoice-year').val();
        var type =  $('#invoice-type').val();

        $.ajax({
            url: '/administracija/racuni/filter',
            type: 'get',
            data : {
                type: type,
                year: year
            }
        }).done(function (rsp) {
            $("#invoices_table").dataTable().fnDestroy();
            $('.invoices-table-body').html(rsp);

            $('#invoices_table').DataTable({
                "paging": true,
                "lengthChange": true,
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "Vsi"]],
                "iDisplayLength": 50,
                "searching": true,
                "ordering": true,
                "info": true,
                "autoWidth": false,
                "responsive": true,
                "language": {
                    "sEmptyTable": "Nobenih podatkov ni na voljo",
                    "sInfo": "Prikazujem _START_ do _END_ od _TOTAL_ zapisov",
                    "sInfoEmpty": "Prikazujem 0 do 0 od 0 zapisov",
                    "sInfoFiltered": "(filtrirano od _MAX_ vseh zapisov)",
                    "sInfoPostFix": "",
                    "sInfoThousands": ",",
                    "sLengthMenu": "Prikaži _MENU_ zapisov",
                    "sLoadingRecords": "Nalagam...",
                    "sProcessing": "Obdelujem...",
                    "sSearch": "Išči:",
                    "sZeroRecords": "Nobeden zapis ne ustreza",
                    "oPaginate": {
                        "sFirst": "Prvi",
                        "sLast": "Zadnji",
                        "sNext": "Nasl.",
                        "sPrevious": "Pred."
                    },
                    "oAria": {
                        "sSortAscending": ": vključite za naraščujoči sort",
                        "sSortDescending": ": vključite za padajoči sort"
                    }
                },
                "columnDefs": [
                    { "width": "20%", "targets": 3 }
                ]
            });

            $('.minimal').iCheck({
                checkboxClass: 'icheckbox_square-blue',
                radioClass: 'iradio_square-blue',
                increaseArea: '20%' // optional
            });
        });
    });

    $('#customer').on('change', function () {
        if ($(this).val() != -1) {
            $('#name').val($(this).val());
            $('#address').val($(this).find(':selected').attr('data-address'));
            $('#zip_code').val($(this).find(':selected').attr('data-zip-code'));
            $('#tax_number').val($(this).find(':selected').attr('data-tax-number'));
            $('#phone').val($(this).find(':selected').attr('data-phone'));
            $('#comments').val($(this).find(':selected').attr('data-comments'));
        }
        else {
            $('#name').val('');
            $('#address').val('');
            $('#zip_code').val('');
            $('#tax_number').val('');
            $('#phone').val('');
            $('#comments').val('');
        }
    });

    $('.btn-status').on('click', function () {
        var status = $('#invoice-status').find(':selected').val();
        var status_text = $('#invoice-status').find(':selected').text();
        var invoice_ids = [];

        $(".invoice-status:checked").each(function () {
            var id = $(this).attr('data-id');
            invoice_ids.push(id);

            $(this).closest('tr').find('.status').text(status_text)
        });

        $.ajax({
            url: '/administracija/racuni/change-status',
            type: 'post',
            data : {
                status: status,
                invoice_ids: invoice_ids
            }
        }).done(function (rsp) {

        });
    });

});

function initProductsTable()
{
    var products_table = $('#products_table').DataTable({
        "paging": true,
        "lengthChange": true,
        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "Vsi"]],
        "searching": true,
        "ordering": true,
        "info": true,
        "autoWidth": false,
        rowReorder: true,
        "responsive": true,
        "language": {
            "sEmptyTable": "Nobenih podatkov ni na voljo",
            "sInfo": "Prikazujem _START_ do _END_ od _TOTAL_ zapisov",
            "sInfoEmpty": "Prikazujem 0 do 0 od 0 zapisov",
            "sInfoFiltered": "(filtrirano od _MAX_ vseh zapisov)",
            "sInfoPostFix": "",
            "sInfoThousands": ",",
            "sLengthMenu": "Prikaži _MENU_ zapisov",
            "sLoadingRecords": "Nalagam...",
            "sProcessing": "Obdelujem...",
            "sSearch": "Išči:",
            "sZeroRecords": "Nobeden zapis ne ustreza",
            "oPaginate": {
                "sFirst": "Prvi",
                "sLast": "Zadnji",
                "sNext": "Nasl.",
                "sPrevious": "Pred."
            },
            "oAria": {
                "sSortAscending": ": vključite za naraščujoči sort",
                "sSortDescending": ": vključite za padajoči sort"
            }
        },
        "columnDefs": [
            { "width": "20%", "targets": 3 }
        ]
    });

    if ($('#product-category option:selected').val() == -1) {
        $('#products_table').find('.drag-column')
            .removeClass('drag-column');
    }
    else {
        products_table.on('row-reorder', function ( e, diff, edit ) {
            $.ajax({
                data: edit.values,
                type: 'POST',
                url: '/administracija/produkti/save-order',
                success:(function(data) {
                })
            });
        });
    }

    $('.product-images').sortable({
        update: function (event, ui) {
            var sorted_images = $(this).sortable('serialize', {
                attribute: 'id'
            });

            $.ajax({
                data: sorted_images,
                type: 'POST',
                url: '/administracija/produkti/slike/save-order',
                success:(function(data) {
                })
            });
        }
    })
        .disableSelection()
        .on('click', '.btn-delete', function () {
            var id = $(this).attr('data-id');
            var div = $(this).closest('.ui-state-default');

            $.ajax({
                type: 'GET',
                url: '/administracija/produkti/zbrisi-sliko/' + id,
                success:(function(data) {
                    div.remove();
                })
            });
        });

    var inputs = document.querySelectorAll('.inputfile');

    Array.prototype.forEach.call(inputs, function (input) {
        var label	 = input.nextElementSibling,
            labelVal = label.innerHTML;

        input.addEventListener('change', function (e) {
            var fileName = '';
            if( this.files && this.files.length > 0 ) {
                fileName = ( this.getAttribute('data-multiple-caption') || '' ).replace('{count}', this.files.length);
            }
            if( fileName ) {
                label.querySelector( 'span' ).innerHTML = fileName;
                $('.btn-upload').removeClass('hidden');
            }
            else {
                label.innerHTML = labelVal;
                $('.btn-upload').addClass('hidden');
            }
        });
    });

    $('.gallery').sortable({
        update: function (event, ui) {
            var sorted_images = $(this).sortable('serialize', {
                attribute: 'id'
            });

            $.ajax({
                data: sorted_images,
                type: 'POST',
                url: '/administracija/galerija/save-order',
                success:(function(data) {
                })
            });
        }
    })
        .disableSelection()
        .on('click', '.btn-delete', function () {
            var id = $(this).attr('data-id');
            var div = $(this).closest('.ui-state-default');

            $.ajax({
                type: 'GET',
                url: '/administracija/galerija/zbrisi-sliko/' + id,
                success:(function(data) {
                    div.remove();
                })
            });
        });;
}